import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import {useRecoilState, useRecoilValue} from "recoil";
import theatreModeState from "../../state/ui/theatreModeState";
import useBodyClass from "../../hooks/ui/useBodyClass";
import {CSSTransition} from "react-transition-group";
import Video from "../../components/Video";
import People from "./BottomCenter/People";
import Settings from "../../components/Settings";
import Chat from "../../components/Chat";
import tabState from "../../state/ui/activeTabState";
import Footer from "../../components/Footer";
import useWindowDimensions from "../../hooks/ui/useWindowDimensions";
import {useLocation} from "react-router-dom";
import BottomBar from "../../components/BottomBar";
import keyboardState from "../../state/ui/keyboardState";
import ExitModal from "../../components/Modal/ExitModal";
import useTiming from "../../hooks/useTiming";
import reviveModeState from "../../state/ui/reviveModeState";
import boothModeState from "../../state/ui/boothModeState";
import PollActionModal from "../../components/Modal/PollActionModal";
import activeModalState from "../../state/ui/activeModalState";
import windowDimensionState from "../../state/ui/windowDimensionState";
import OverlayNotice from "../../components/OverlayNotice";
import Track from "../../components/Track"
import BoothPages from "./BottomCenter/BoothPages";
import HomeNavigation from "./LeftPanel/HomeNavigation";
import BoothNavigation from "./LeftPanel/BoothNavigation";
import { useTranslation } from "react-i18next";
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import useLoginFirebase from "../../hooks/useLoginFirebase";
import useSession from "../../hooks/useSession";

export default function SpaceLayout ({children}) {
  useLoginFirebase(); 
  useSession();
  
  const {height} = useWindowDimensions();
  const theatreMode = useRecoilValue(theatreModeState);
  const keyboard = useRecoilValue(keyboardState);
  const activeTab = useRecoilValue(tabState);
  const timing = useTiming();
  const [reviveMode, setReviveMode] = useRecoilState(reviveModeState);

  const [boothMode, setBoothMode] = useRecoilState(boothModeState);

  const windowDimensions = useRecoilValue(windowDimensionState);
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const isMobileView = windowDimensions.width < 768;

  const {t} = useTranslation('lounge')

  useBodyClass('body-no-scroll');

  const nodeRef = useRef(null);

  const [startAnimation, setStartAnimation] = useState(false);
  useEffect(() => {
    setStartAnimation(true);
    setReviveMode(timing.venue.type == 'vod')
  }, []);

  const loungeRef = useRef(null)
  const { pathname } = useLocation();
  useEffect(() => {
    loungeRef.current && loungeRef.current.scrollTo(0, 0);
  }, [pathname]);


  const route = useRouteMatch({
    path: "/:timing",
  });
  const history = useHistory();
  const resetLoungePage = () => {
      history.push(route);
  }

  const quitBoothMode = () => {
    setBoothMode((prev)=>(!prev))
    setShowModal('')
    resetLoungePage() //Ensure lounge show listing page when user quite from booth mode
  }

  return (
    <div className={`bg-black space-layout ${reviveMode ? 'revive-mode':''} ${theatreMode? 'theatre-mode':''} ${keyboard? 'keyboard-mode':''}`} style={{ height: height }}>
      <CSSTransition in={startAnimation} nodeRef={nodeRef} classNames="curtain-transition" timeout={3000} mountOnEnter>
        <div ref={nodeRef} className="overflow-hidden bg-black relative h-screen">
          <div className={`${boothMode ? "bg-gradient-to-b from-blue-900 via-indigo-900 to-black brightness-75 saturate-150 h-full" : "bg-curtain fixed"}`}>
            <div className="bg-curtain-overlay"/>
          </div>
          {boothMode ? <Track/> : <Video/>}
          <div
            ref={loungeRef}
            className={classNames(
              "page tab-view bg-panel custom-scrollbar tab-view-inset-padding",
              {
                "hidden user-select-none": activeTab !== 0,
              }
            )}
          >
          {boothMode ? <BoothNavigation /> : <HomeNavigation />}
          </div>
          {boothMode ? <BoothPages /> : <People />}
          {
            reviveMode ?
              <div className="panel-setting">
                <Settings/>
              </div>
            :
              <div className="panel-right bg-panel">
                <Settings/>
                <Chat/>
              </div>
          }
          {boothMode && <PollActionModal/>}
          <ExitModal/>
          <BottomBar/>
        </div>
      </CSSTransition>
      {boothMode && isMobileView &&
        <OverlayNotice>
          <p className="w-16 mx-auto">
            <i className="fas fa-desktop text-5xl text-white"></i>
          </p>
          <h1 className="text-white text-lg font-semibold my-2">Control Booth is only available on desktop mode.</h1>
          <button className="btn-primary" onClick={quitBoothMode}>
            {boothMode ? t('booth:quit-control-booth') : t('booth:enter-control-booth')}
          </button>
        </OverlayNotice>
      }
      <OverlayNotice wrapperClassName={"orientation-lock"}>
        <p className="w-16 mx-auto">
          <svg id="bold" enableBackground="new 0 0 24 24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
            <g><path d="m22.432 7.344-.688-.688-4.401-4.401-.688-.688c-.834-.834-2.288-.737-3.242.216l-11.629 11.632c-.953.953-1.05 2.407-.216 3.242l5.776 5.776c.834.834 2.288.737 3.242-.216l11.631-11.631c.953-.954 1.05-2.408.215-3.242zm-1.473 2.298-11.317 11.317c-.347.347-.875.382-1.179.079l-5.501-5.501c-.304-.304-.269-.832.079-1.179l11.317-11.317c.347-.347.875-.382 1.179-.079l.275.275c.304.304.269.832-.079 1.179-.347.347-.382.875-.079 1.179l2.751 2.751c.304.304.832.269 1.179-.079.347-.347.875-.382 1.179-.079l.275.275c.303.304.268.832-.079 1.179z"/></g><g><path d="m13.836 24c-.336 0-.641-.202-.772-.513-.131-.313-.06-.674.18-.914l2.38-2.38c.167-.167.398-.257.633-.244.236.012.457.123.606.306l.882 1.079c2.697-1.433 4.555-4.265 4.581-7.504.004-.46.377-.83.836-.83h.007c.462.004.833.381.83.843-.043 5.556-4.6 10.113-10.156 10.157-.002 0-.004 0-.007 0z"/></g><g><path d="m10.164 0c.336 0 .641.202.772.513.131.313.06.674-.18.914l-2.38 2.38c-.168.167-.399.258-.634.244-.236-.012-.457-.123-.606-.306l-.882-1.079c-2.697 1.433-4.555 4.265-4.581 7.504-.004.46-.378.83-.837.83-.002 0-.004 0-.007 0-.461-.004-.832-.381-.829-.843.044-5.556 4.601-10.113 10.157-10.157z"/></g>
          </svg>
        </p>
        <h1 className="text-white text-lg font-semibold my-2">Please rotate your phone.</h1>
      </OverlayNotice>
    </div>
  );
}
